var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "32 / abb_location_OK") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M16,1.00089005 C9.48007514,0.921816464 4.11949113,6.12143144 4,12.6405509 C4,22.8184361 16,31.5454545 16,31.5454545 C16,31.5454545 28,22.8184361 28,12.6405509 C27.8805089,6.12143144 22.5199249,0.921816464 16,1.00089005 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11,0.000815878416 C16.9765978,-0.0716682417 21.8904665,4.69464549 22,10.670505 C22,20.0002331 11,28 11,28 C11,28 0,20.0002331 0,10.670505 C0.109533535,4.69464549 5.02340221,-0.0716682417 11,0.000815878416 Z M11,6.00064105 C8.23857625,6.00064105 6,8.23915207 6,11.0004954 C6,13.7618386 8.23857625,16.0003497 11,16.0003497 C13.7614237,16.0003497 16,13.7618386 16,11.0004954 C16,8.23915207 13.7614237,6.00064105 11,6.00064105 Z",
    id: "path-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "32-/-abb_location_OK",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9-Copy"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    stroke: "none",
    fill: "#007C2B",
    fillRule: "nonzero",
    xlinkHref: "#path-3"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenMarker);
export default __webpack_public_path__ + "static/media/Green-marker.f0f70d6f62e41f32022d83187b670263.svg";
export { ForwardRef as ReactComponent };